(function(){
  console.log('home');
})();